import React from 'react'
import * as EDT from '../../../Type/EnhancedData'
import { ProductLineItemDataContainer } from './Level3Segments/ProductLineItemDataContainer'
import { TaxInformation } from './Level3Segments/TaxInformation'

export function LevelThreeSection (props: EDT.L3SectionProps): React.JSX.Element {
  const { selectedTaxOption, onTaxOptionChange } = props
  return (
    <div className="level-3-section">
      <TaxInformation
        selectedTaxOption={selectedTaxOption}
        onTaxOptionChange={onTaxOptionChange}
      />
      <ProductLineItemDataContainer {...props} selectedTaxOption={selectedTaxOption} />
    </div>
  )
}
